module.exports = __webpack_public_path__ + "img/logo-icon-app.f353907b.png";